import axiosInstance from './config/api';
import type { CallDirectionType } from 'types/call.type';

export const getDashboardMetrics = (campaignId: string) =>
    axiosInstance.get(`/dashboard/metrics?campaignId=${campaignId}`).then((res) => res.data);

export type DashboardDataParams = {
    startDate?: string;
    endDate?: string;
    workflowId?: string;
    callDirection?: Exclude<CallDirectionType, 'ALL'>; // Only send INBOUND | OUTBOUND
};

export const getDashboardData = async (params: DashboardDataParams) => {
    return await axiosInstance.get('/dashboard', { params }).then((res) => res.data);
};
